import type { Terminal } from '../terminal';

const GAME_LIST = [
  'FALKEN\'S MAZE',
  'BLACK JACK',
  'GIN RUMMY',
  'HEARTS',
  'BRIDGE',
  'CHECKERS',
  'CHESS',
  'POKER',
  'FIGHTER COMBAT',
  'GUERRILLA ENGAGEMENT',
  'DESERT WARFARE',
  'AIR-TO-GROUND ACTIONS',
  'THEATERWIDE TACTICAL WARFARE',
  'THEATERWIDE BIOTOXIC AND CHEMICAL WARFARE',
  '',
  'GLOBAL THERMONUCLEAR WAR',
];

type GameSelection = 'thermonuclear_war' | 'chess';

async function runGameSelect(terminal: Terminal): Promise<GameSelection> {
  await terminal.println('');
  await terminal.println('SHALL WE PLAY A GAME?', { cssClass: 'bright' });
  await terminal.pause(1000);
  await terminal.println('');

  const input = await terminal.waitForInput('> ');

  if (input.toUpperCase().includes('LIST') || input.toUpperCase().includes('GAME') || input.toUpperCase().includes('YES') || input.toUpperCase().includes('Y')) {
    await terminal.println('');
    for (const game of GAME_LIST) {
      if (game === '') {
        await terminal.println('');
        continue;
      }
      await terminal.println(`  ${game}`, { speed: 15 });
    }
    await terminal.println('');
  }

  // Now get game selection
  let selecting = true;
  while (selecting) {
    const choice = await terminal.waitForInput('WHICH GAME? ');
    const upper = choice.toUpperCase();

    if (upper.includes('GLOBAL') || upper.includes('THERMONUCLEAR') || upper.includes('WAR')) {
      await terminal.println('');
      await terminal.println('WOULDN\'T YOU PREFER A NICE GAME OF CHESS?', { cssClass: 'warning' });
      await terminal.println('');
      const confirm = await terminal.waitForInput('> ');
      const confirmUpper = confirm.toUpperCase();

      if (confirmUpper.includes('CHESS') || confirmUpper === 'YES' || confirmUpper === 'Y') {
        return 'chess';
      }

      await terminal.println('');
      await terminal.println('FINE.', { speed: 80 });
      await terminal.pause(500);
      await terminal.println('');
      return 'thermonuclear_war';
    }

    if (upper.includes('CHESS')) {
      return 'chess';
    }

    // Any other game - redirect to thermonuclear war
    await terminal.println('');
    await terminal.println('THAT GAME IS CURRENTLY UNAVAILABLE.', { cssClass: 'dim' });
    await terminal.println('PERHAPS SOMETHING MORE... STIMULATING?', { cssClass: 'dim' });
    await terminal.println('');
  }

  return 'thermonuclear_war';
}

export { runGameSelect };
export type { GameSelection };
